import React, { useState } from 'react';
import { Accordion, CheckboxInput, Typography } from '@guildeducationinc/recess';
import { useHits, useToggleRefinement } from 'react-instantsearch-hooks-web';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { useSearchContext } from '@src/components/Providers/SearchProvider/SearchProvider';
import { trackFilterEvents } from '../filterHelpers';

export const ACCEPTING_APPLICATIONS_FILTER_LABEL = 'Only show open programs';

export const AcceptingApplicationsFilter: React.FC = () => {
	const [toggleAccordion, setToggleAccordion] = useState<boolean>(true);

	const { results } = useHits();
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const { index } = useSearchContext();

	const { refine, value } = useToggleRefinement({
		attribute: 'isAcceptingApplications',
	});

	const { isRefined } = value;

	const FilterTitle: React.FC = () => {
		return (
			<Typography testid='accepting-applications-title' variant='h6'>
				Accepting applications
			</Typography>
		);
	};

	return (
		<Accordion
			defaultOpen={toggleAccordion}
			testid='acceptingApplicationsFilterAccordion'
			title={FilterTitle}
		>
			<CheckboxInput
				checked={isRefined}
				label={
					<Typography variant='body1' weight='normal'>
						{ACCEPTING_APPLICATIONS_FILTER_LABEL} ({value?.onFacetValue?.count})
					</Typography>
				}
				name='isAcceptingApplications'
				onChange={event => {
					const showOpenPrograms = event.target.checked;
					refine({ isRefined: !showOpenPrograms });
					setToggleAccordion(true);
					const eventName = showOpenPrograms ? 'FilterAdded' : 'FilterRemoved';
					trackFilterEvents(
						'isAcceptingApplications',
						eventName,
						'isAcceptingApplications',
						ACCEPTING_APPLICATIONS_FILTER_LABEL,
						index,
						results,
						user
					);
				}}
			/>
		</Accordion>
	);
};
